module.exports = __webpack_public_path__ + "img/log.00bc9319.png";